import { ShoppingItemsDataGateway } from '../../../account/providers/shopping-items-data-gateway';
import { Utils } from '../../../../providers/utils';
import { RecipeListPageFull } from '../recipe-list/recipe-list.full';
import { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
import { LocalRecipeBoxData } from '../../providers/local-recipe-box-data';
import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { NavController, Events, LoadingController, NavParams } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { RecipeData } from '../../providers/recipe-data';
import { RecipeDetailCommon } from './recipe-detail.common';
//import { ElasticResult } from '../../../../providers/elastic-search';

@Component({
	selector: 'page-recipe-detail-full',
	templateUrl: 'recipe-detail.full.html'
})
export class RecipeDetailPageFull extends PageBase {

	recipeModel = {
		isFavorite: false,
		userRecipeId: '',
		calories: {
				amount: {
					quantity: 0,
					unit: ''
				}
			}
	};
	recipeNutritionSumary = [];
	recipeNutritionSumaryHtml = '';
	loader: any;
	ingredientTab = true;
	nutritrionTab = false;
	directionTab = false;
	recipeBoxData: any;
	userId = '';
	recipeId = '';
	categoryUrlSlug = '';
	category = {};
	isAddAllShoppingList = false;
	shoppingList: any;
	shoppingItemsData: any;

	tabIngredients = true;
	tabCalories = false;
	tabDirections = false;

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: RecipeDetailCommon,
		public recipeData: RecipeData,
		public loadingCtrl: LoadingController,
		private navParams: NavParams,
		public localRecipeBox: LocalRecipeBoxData,
		public recipeBoxGateway: RecipeBoxDataGateway,
		public shoppingItemsDataGateway: ShoppingItemsDataGateway

	) {
		super(settings, events, nav, userData);
		this.recipeId = navParams.get('id');
		this.categoryUrlSlug = navParams.get('categoryUrlSlug');
	}

	loadData() {
		var self = this;
		self.recipeModel = {
			isFavorite: false,
			userRecipeId: '',
			calories: {
				amount: {
					quantity: 0,
					unit: ''
				}
			}
		};

		self.loader = this.loadingCtrl.create();
		self.loader.present();
		self.recipeData.getRecipeDetail(this.userId, self.recipeId).subscribe(recipe => {
			if (!recipe) {
				return;
			}

			self.recipeModel = recipe;
			if (!recipe.nutritionFacts) {
				return;
			}
			self.recipeModel = recipe;
			let caloryNutrition = _.find(recipe.nutritionFacts, (nutritionFact: any) => {

				return nutritionFact.name == "Calories";
			});
			this.recipeModel.calories = caloryNutrition;
			// if (recipe.nutritionFacts.calories) {
			// 	var caloryNutrition = {
			// 		abbrName: "Calories",
			// 		amount: recipe.nutritionFacts.calories,
			// 		name: "Calories",
			// 		order: 0,
			// 		percent: -1,
			// 		primary: true
			// 	};
			// 	nutritionArray.push(caloryNutrition);
			// }
			// _.forEach(recipe.nutritionFacts.nutritions, function (nutrition: any) {
			// 	if (nutrition.primary && nutrition.primary == true) {
			// 		if (nutritionArray && nutritionArray.length == 6) {
			// 			nutritionArray = [];
			// 			index++;
			// 		}
			// 		nutritionArray.push(nutrition);
			// 		self.addNutritionChildToArr(nutrition, nutritionArray, index);
			// 		self.recipeNutritionSumary[index] = nutritionArray;
			// 	}
			// });
			this.getShopingList().subscribe((shippingList: any) => {
				this.shoppingList = shippingList;
				// _.forEach(recipe.ingredients, (ingredient: any) => {
				// 	this.checkIngredientIsAddToList(ingredient);
				// });
				this.checkIngredientsAreAddToList(recipe.ingredients);
			});
		});

		self.recipeData.getAllCategories().subscribe(categoriesRes => {
			self.category = _.find(categoriesRes, (value: any, key) => {
				return value.urlSlug == self.categoryUrlSlug;
			});
		});
		self.loader.dismiss();
	}

	addOrRemoveUserRecipe() {
		if (!this.recipeModel.isFavorite) {
			// create node user recipe in firebase then save new key to local storage
			this.recipeBoxData.add(this.userId, this.recipeModel).then(userRecipe => {
				this.recipeModel.isFavorite = true;
				this.recipeModel.userRecipeId = userRecipe.$key;
			});
		}
		else {
			this.recipeBoxData.remove(this.userId, this.recipeModel).then(result => {
				if (result)
					this.recipeModel.isFavorite = false;
			});
		}
	}

	getNutritionBackground(nutrition) {
		var percent = nutrition.percent;
		if (nutrition.percent <= -1) {
			percent = nutrition.amount / 20;
		}
		return 'linear-gradient(to top, rgb(190, 218, 217) ' + percent + '%, rgb(245, 245, 245) ' + percent + '%)';
	}

	addNutritionChildToArr(nutrition, nutritionArray, index) {
		_.forEach(nutrition.child, function (nutritionChild) {
			if (nutritionChild.primary && nutritionChild.primary == true) {
				if (nutritionArray && nutritionArray.length == 6) {
					nutritionArray = [];
					index++;
				}
				nutritionArray.push(nutritionChild);
			}
		});
	}

	viewRecipeCategory(categoryUrlSlug) {
		if (!categoryUrlSlug)
			categoryUrlSlug = 'all';
		this.nav.push(RecipeListPageFull, { categoryUrlSlug: categoryUrlSlug });
	}

	//Init functions
	ngAfterViewInit() {
	}

	ionViewDidEnter() {
		this.loader = this.loadingCtrl.create();
		this.userId = this.currentUser ? this.currentUser.uid : '';
		this.recipeBoxData = this.recipeBoxGateway.getService(this.userId);
		this.shoppingItemsData = this.shoppingItemsDataGateway.getService(this.userId);
		this.loadData();
	}

	viewTab(tabIngredients, tabCalories, tabDirections) {
		this.tabIngredients = tabIngredients;
		this.tabCalories = tabCalories;
		this.tabDirections = tabDirections;
	}
	checkIngredientsAreAddToList(ingredients) {
		this.isAddAllShoppingList = false; // to add all
		_.forEach(ingredients, (ingredient: any) => {
			this.checkIngredientIsAddToList(ingredient).then(isExist => {
				if (isExist) {
					this.isAddAllShoppingList = true; // to remove all
				}
			});
		});
	}
	checkIngredientIsAddToList(ingredient) {
		return new Promise((resolve, reject) => {
			let ingredientResult = _.find(this.shoppingList, (item: any) => {
				return item.ingredientId == ingredient.ingredientId && item.refId == this.recipeId;
			});
			if (ingredientResult) {
				ingredient.shoppingItemKey = ingredientResult.$key;
				resolve(true);
			}
			else {
				resolve(false);
			}
		});
	}
	removeIngredients(ingredients) {
		_.forEach(ingredients, (ingredient: any) => {
			this.removeIngredient(ingredient);
		});
		this.isAddAllShoppingList = !this.isAddAllShoppingList;

	}
	addIngredients(ingredients) {
		_.forEach(ingredients, (ingredient: any) => {
			this.addIngredient(ingredient);
		});
		this.isAddAllShoppingList = !this.isAddAllShoppingList;
	}
	addIngredient(ingredient) {

		if (ingredient.shoppingItemKey) {
			return;
		}
		
		var categories = this.recipeModel['categories'];
		categories = Utils.toArray(categories).reverse();

		//sample data to Shopping List
		var ingredientFb = {
			catQuantity: 0,
			categoryName: 'Ingredients',
			description: ingredient.amount.quantity + ' ' + ingredient.amount.unit + ' ' + ingredient.product,
			displayPrice: '$1',
			displaysalePrice: 'On Sale: 80 cent',
			itemIcon: 'itemIcon',
			itemIconText: 'itemIconText',
			itemName: ingredient.product,
			itemType: 'Ingredients',
			ingredientId: ingredient.ingredientId || ingredient.sku,
			quantity: 1,
			refDes: this.recipeModel['title'],
			refId: this.recipeModel['$key']? this.recipeModel['$key'] : this.recipeId,
			salePrice: '100',
			thumbnail: 'http://previews.123rf.com/images/rrraven/rrraven1406/rrraven140600152/29539686-vector-black-sugar-bag-icon-on-white-Stock-Vector-sugar.jpg'
		};
		return this.shoppingItemsData.add(this.userId, ingredientFb).then((ingredientResult: any) => {
			ingredient.shoppingItemKey = ingredientResult.$key;

		});

	}
	removeIngredient(ingredient) {
		if (!ingredient.shoppingItemKey) {
			return;
		}
		console.log(ingredient);

		return this.shoppingItemsData.remove(this.userId, ingredient.shoppingItemKey).then(removeResult => {
			// setTimeout(function () {
			delete ingredient.shoppingItemKey;
			this.isAddAllShoppingList
			return ingredient;
			// }, 50);
		});

	}
	addOrRemoveIngredient(ingredient) {
		if (!ingredient.shoppingItemKey && ingredient.shoppingItemKey != '') {
			this.addIngredient(ingredient);
		}
		else {
			this.removeIngredient(ingredient);
		}
	}
	getShopingList() {
		return this.shoppingItemsData.get(this.userId).map(shopitems => {
			console.log(shopitems);
			return Utils.toAngularFireArray(shopitems).reverse();
		});
	}
	addOrRemoveIngredients(ingredients) {
		if (!this.isAddAllShoppingList) {
			this.addIngredients(ingredients);
		}
		else {
			this.removeIngredients(ingredients);
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-detail/recipe-detail.full.ts